import styled from 'styled-components';
import {
  MenuList,
  MenuListItem,
} from '@pearsontechnology/aero-components';

export const CoursewareList = styled(MenuList)`
  padding: 20px 30px 140px;
  height: 339px;
  overflow: -moz-scrollbars-none;
  overflow: hidden;
  overflow-y: auto;
`;

export const CoursewareListItem = styled(MenuListItem)`
  display: flex;
  height: auto;
  min-height: min-content;
  font-size: 14px;
  line-height: 18px;
  padding-top: 5px;
  padding-bottom: 5px;
  overflow-wrap: break-word;
  word-break: break-word;

  &:focus {
    box-shadow: none;
  }

  & svg {
    margin-right: 15px;
  }
`;

export const FormField = styled.div`
  height: auto;
  overflow: -moz-scrollbars-none;
  overflow: hidden;
  overflow-y: auto;
`;

export const CheckBoxContainer = styled.div`
  margin-top: 10px;
`;

export const Italic = styled.p`
  font-style: italic
`;
